import { getIsWideWorkspace } from 'utils/documentPanes';

const getScreen = () => (typeof window === 'undefined' ? null : window.screen);

const getIsScreenExtended = () => {
  const screen = getScreen();

  return !!(screen && 'isExtended' in screen && screen.isExtended);
};

export const checkIsWideWorkspace = () =>
  getIsWideWorkspace({
    isScreenExtended: getIsScreenExtended(),
    innerWidth: typeof window === 'undefined' ? 0 : window.innerWidth,
  });
